<template>
    <el-drawer title="选择演出" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        append-to-body @close="close">
        <div class="drawer-content" v-loading="listLoading">
            <div class="page-filter-box">
                <el-row :gutter="10">
                    <el-col :sm="12">
                        <el-input v-model="params.searchValue" class="input-with-select" size="small">
                            <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                                <el-option label="演出ID" :value="1"></el-option>
                                <el-option label="演出名称" :value="2"></el-option>
                            </el-select>
                        </el-input>
                    </el-col>
                    <el-col :sm="12" class="page-filter-btns">
                        <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                        <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                    </el-col>
                </el-row>
            </div>
            <div class="list-box">
				<el-table
				    :data="dataList"
				    border
				    style="width: 100%"
				    v-loading="listLoading"
				    size="small"
				    stripe
				    @selection-change="handleSelectionChange"
				>
				    <el-table-column type="selection"></el-table-column>
				    <el-table-column prop="status" label="演出海报">
						<template slot-scope="scope"><el-image :src="scope.row.poster | coverImage(300, 400)" fit="cover" :preview-src-list="[scope.row.poster]"></el-image></template>
				    </el-table-column>
				    <el-table-column prop="title" label="标题" min-width="200" show-overflow-tooltip></el-table-column>
				    <el-table-column  label="城市&场地名称" min-width="250">
						<template slot-scope="scope">
						    <p>城市：{{scope.row.cityName}}</p>
						    <p>场地名称：{{scope.row.siteName}}</p>
						</template>
					</el-table-column>
				   <el-table-column prop="totalTicket" label="总库存"></el-table-column>
				   <el-table-column prop="sellTicket" label="已售"></el-table-column>
				   <el-table-column prop="minPrice" label="最小票价"></el-table-column>
				</el-table>
				
                
            </div>
            <el-empty v-if="data && dataList.length < 1" description="没有相关演出" :image-size="100"></el-empty>
            <div v-if="data" class="page-pagination-box MT20">
                <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                    :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                    layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
                </el-pagination>
            </div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()">确认</el-button>
        </div>
    </el-drawer>
</template>
<script>
const defaultParams = {
    pageNo: 1,
    searchType: 1,
    searchValue: "",
	cpsType:1
}
export default {
	props: {
	    formData:{
	        type: Object,
	        default: null
	    }
	},
    data() {
        return {
            drawerShow: false,
            listLoading: true,
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageSize: this.$pageSizes[0]
            },
   //          currentIndex: "",
			// tabaleDataSelected: [],
			activityList2:[],
			userIds:[],
        }
    },
    watch: {
       
    },
    methods: {
        close() {
            this.drawerShow = false;
            this.params = {
                ...defaultParams,
                pageSize: this.$pageSizes[0]
            }
            this.currentIndex = "";
			
        },
        show() {
            this.getDataList();
            this.drawerShow = true;
			console.log(this.formData)
        },
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/activity/cps/activityList",
                method: "POST",
                params: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
						
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        handleSelectionChange(val) {
            console.log(val)
			let _attachInfo = [];
			val.forEach((v, i) => {
			    _attachInfo.push({
					activityId:v.id,
					title:v.title,
					douyinPoiId:v.douyinPoiId,
					ratio:0					
			    })
			})
			this.activityList2 = _attachInfo
			this.userIds = val.map( v => v.id );
        },
        submitForm() {            
			if( this.userIds < 1  ){
				 return this.$message.error('请选择演出')
			}			
			if( this.formData.activityList && this.formData.activityList.length > 0 ){				
				this.formData.activityList = this.formData.activityList.concat(this.activityList2);
			}else{
				this.formData.activityList = this.activityList2
			}
			this.formData.activityList = this.formData.activityList.filter((item, index) => {
			  return this.formData.activityList.findIndex(obj => obj.activityId === item.activityId && obj.title === item.title) === index;
			});
			
            this.close();
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-drawer {
    max-width: 100%;

    .page-filter-box {
        .input-with-select {
            display: inline-table;
        }
    }
}

.list-box {
    display: flex;
    flex-wrap: wrap;

    .item {
        margin: 5px;
        display: flex;
        border: 1px #eee solid;
        width: 370px;
        padding: 15px;
        cursor: pointer;
        position: relative;
        border-radius: 3px;
        box-shadow: 0 2px 8px #eee;
        transition: all 0.5s ease-out;

        .poster {
            margin-right: 10px;
            background: #f8f8f8;

            .el-image {
                width: 90px;
            }
        }

        .info {
            flex: 1;

            .name {
                font-size: 15px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                height: 36px;
                line-height: 18px;
                margin: 0;
            }

            >div {
                margin-top: 6px;
                font-size: 12px;
                display: flex;
                align-items: flex-end;

                >div {
                    margin-right: 20px;
                }

                .price {
                    font-size: 18px;
                    font-weight: 700;
                    line-height: 1;
                }
            }
        }

        .icon {
            position: absolute;
            right: 15px;
            bottom: 15px;
            color: $--color-theme;
            font-size: 18px;
            display: none;
            transition: all 0.5s ease-out;
        }

        &.current {
            border-color: $--color-theme;
            box-shadow: 0 2px 8px #bbb;

            .icon {
                display: block;
            }
        }
    }

}

::v-deep .el-empty {
    text-align: center;

    .el-empty__image {
        margin: 0 auto;
    }
}
</style>